/*
 * Journey Monitor recorder (integrated1, docs/journey-monitor-runbook.md, phase 2).
 *
 * Loaded by layout/theme.liquid only when the owner switched it on (shop metafield
 * sks_jm.config, written by integrated1), or with ?jm=1 for a preview check. It records, for
 * each page a HUMAN visitor sees, what tells whether the shop works:
 *   - the page context (template, language, market, device class, referrer domain);
 *   - clicks (stable selector, Shopify section, position), rage clicks (3 in a second on the
 *     same spot) and dead clicks (an interactive element that does nothing for a second);
 *   - scroll depth, own JS errors, failed requests of the cart and of our apps;
 *   - Core Web Vitals (LCP, INP, CLS) as Google counts them, with their parts and the element responsible;
 *   - funnel steps (size chosen, added to cart, checkout pressed) and quick backs.
 * Never: what is typed in a field, the IP, a cookie, an id that survives the tab, a link to the
 * customer. The session id lives in sessionStorage and dies with the tab.
 *
 * Bots: nothing is recorded before a trusted human gesture (pointer moving along a curve, touch,
 * key, wheel/scroll, click). A page left without one sends, for 1% of such pages, a tiny counter
 * (landing, referrer type, device, a few headless hints) so the bot share stays measurable.
 *
 * Replay (phase 4, cfg.replay / cfg.replayFull, off by default): a share of human sessions loads
 * rrweb (rrweb-record.min.js, after the gesture, once the visitor has been still for 1.5 s and the
 * browser is idle: a page snapshot is one block of work) and keeps the last 30-60 s in memory, sent only when something goes wrong (own JS error, rage click, dead click on
 * a button or link, failed add to cart) and for the next two minutes of the session; a small
 * sample is sent whole. Every input and the text inside forms is masked; the search box's
 * suggestions and recent searches (they repeat what was typed) are left out, search pages are not
 * replayed and addresses lose their query; iframes, video, canvas, fonts and images are not
 * copied. ?jm=2 records the session whole, for a check.
 */
(function () {
  "use strict";

  if (window.__sksJourneyRecorder) return;
  window.__sksJourneyRecorder = true;
  var cfg = {};
  try { cfg = JSON.parse((document.getElementById("sks-jm-config") || {}).textContent || "{}") || {}; } catch (e) { cfg = {}; }
  var ENDPOINT = cfg.endpoint || "";
  if (!ENDPOINT) return;
  if (window.__sksJmForced) ENDPOINT += (ENDPOINT.indexOf("?") === -1 ? "?" : "&") + "jm=1";   // a ?jm=1 check while off

  var UA = navigator.userAgent || "";
  if (navigator.webdriver || /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|SkisisesJourneyMonitor/i.test(UA)) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (/^\/(account|[a-z]{2}(-[a-z]{2})?\/account)(\/|$)/i.test(location.pathname)) return;

  function consentOk() {
    if (cfg.consent !== "analytics") return true;
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(api && api.analyticsProcessingAllowed && api.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }

  function rid(n) {
    var out = "";
    var chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    try {
      var bytes = new Uint8Array(n);
      crypto.getRandomValues(bytes);
      for (var i = 0; i < n; i++) out += chars[bytes[i] % 36];
    } catch (e) {
      for (var j = 0; j < n; j++) out += chars[Math.floor(Math.random() * 36)];
    }
    return out;
  }
  var SID_KEY = "sks_jm_s";
  var sid;
  try {
    sid = sessionStorage.getItem(SID_KEY);
    if (!sid) { sid = rid(16); sessionStorage.setItem(SID_KEY, sid); }
  } catch (e) { sid = rid(16); }
  var pid = rid(12);
  var t0 = Date.now();
  var LIMIT = { clicks: 60, errors: 20, cart: 20, res: 20 };

  var vw = window.innerWidth || 0;
  var page = {
    v: 1, sid: sid, pid: pid,
    tpl: String(cfg.template || ""), hdl: String(cfg.handle || ""),
    path: location.pathname.slice(0, 200),
    loc: (window.Shopify && Shopify.locale) || document.documentElement.lang || "",
    mkt: (window.Shopify && Shopify.country) || "",
    cur: (window.Shopify && Shopify.currency && Shopify.currency.active) || "",
    dev: vw < 768 ? "m" : vw < 1024 ? "t" : "d",
    vw: vw, vh: window.innerHeight || 0,
    ref: refType(), utm: utm(), theme: String(cfg.theme || "")
  };
  var rec = { clicks: [], rage: 0, dead: 0, deadI: 0, errors: [], cart: [], res: [], scroll: 0, vit: {}, f: {} };

  function refType() {
    var r = document.referrer;
    if (!r) return "";
    try {
      var host = new URL(r).hostname;
      return host === location.hostname ? "self" : host.replace(/^www\./, "").slice(0, 60);
    } catch (e) { return "other"; }
  }
  function utm() {
    try {
      var p = new URLSearchParams(location.search);
      var src = p.get("utm_source"), med = p.get("utm_medium"), camp = p.get("utm_campaign");
      if (p.get("gclid") || p.get("gbraid") || p.get("wbraid")) return "google-ads";
      if (p.get("fbclid")) return "meta";
      return src ? [src, med || "", camp || ""].join("/").slice(0, 80) : "";
    } catch (e) { return ""; }
  }

  /* ------------------------------------------------------------ selectors */
  var HASHED = /^(css-|sc-|jsx-|svelte-)|[0-9a-f]{6,}|^_[a-z0-9]+_/i;
  // Attributes, not properties: a product form's <input name="id"> hides form.id (it would read "[object HTMLInputElement]").
  function selector(el) {
    var parts = [];
    for (var node = el, depth = 0; node && node.nodeType === 1 && depth < 5; node = node.parentElement, depth++) {
      var tag = node.tagName.toLowerCase();
      if (tag === "body" || tag === "html") break;
      var id = node.getAttribute("id") || "";
      if (id && !HASHED.test(id) && !/^shopify-section-/.test(id)) { parts.unshift(tag + "#" + id); break; }
      var part = tag;
      var data = ["data-target", "data-action", "name", "aria-controls", "data-add", "data-variant"].filter(function (a) { return node.hasAttribute && node.hasAttribute(a); })[0];
      if (data && data !== "data-variant") part += "[" + data + "=\"" + String(node.getAttribute(data)).slice(0, 30) + "\"]";
      var cls = String(node.getAttribute("class") || "").split(/\s+/).filter(function (c) { return c && !HASHED.test(c) && c.length < 40; }).slice(0, 2);
      if (cls.length) part += "." + cls.join(".");
      parts.unshift(part);
    }
    return parts.join(">").slice(0, 200);
  }
  function section(el) {
    var s = el && el.closest && el.closest("[id^='shopify-section-']");
    return s ? String(s.getAttribute("id")).replace("shopify-section-", "").slice(0, 80) : "";
  }
  function interactive(el) {
    if (!el || !el.closest) return false;
    if (el.closest("a[href],button,input,select,textarea,label,summary,[role=button],[role=link],[onclick],[tabindex]")) return true;
    try { return getComputedStyle(el).cursor === "pointer"; } catch (e) { return false; }
  }
  // Search suggestions repeat what the visitor typed: no label there, only the selector.
  var TYPED = "predictive-search,[role=listbox],[role=option],[data-luxe-search-suggest],.predictive-search";
  function label(el) {
    var target = el.closest && el.closest("a,button,[role=button],label,summary");
    if (!target || target.closest(TYPED)) return "";
    return (target.getAttribute("aria-label") || target.textContent || "").replace(/\s+/g, " ").trim().slice(0, 40);
  }

  /* ------------------------------------------------------------ the human gate */
  var human = false;
  var waiters = [];
  var moves = [];
  function markHuman() {
    if (human) return;
    if (!consentOk()) return;
    human = true;
    page.hAt = Date.now() - t0;
    waiters.splice(0).forEach(function (fn) { try { fn(); } catch (e) {} });
  }
  function onHuman(fn) { if (human) fn(); else waiters.push(fn); }
  var lastInput = Date.now();
  ["pointerdown", "touchstart", "keydown", "wheel"].forEach(function (name) {
    window.addEventListener(name, function (e) { if (e.isTrusted) { lastInput = Date.now(); markHuman(); } }, { capture: true, passive: true });
  });
  window.addEventListener("scroll", function (e) {
    if (!e.isTrusted) return;
    lastInput = Date.now();
    if (window.scrollY > 40) markHuman();
  }, { passive: true });
  window.addEventListener("pointermove", function (e) {
    if (human || !e.isTrusted) return;
    moves.push([e.clientX, e.clientY]);
    if (moves.length > 6) moves.shift();
    for (var i = 2; i < moves.length; i++) {   // a hand never moves along one straight line
      var a = moves[i - 2], b = moves[i - 1], c = moves[i];
      if (Math.abs((b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0])) > 30) { markHuman(); return; }
    }
  }, { passive: true });

  /* ------------------------------------------------------------ clicks, rage, dead */
  var recent = [];
  var clickSeq = 0;
  document.addEventListener("click", function (e) {
    if (!e.isTrusted) return;
    markHuman();
    if (!human) return;
    var el = e.target && e.target.nodeType === 1 ? e.target : e.target && e.target.parentElement;
    if (!el) return;
    var now = Date.now();
    var click = { t: now - t0, s: selector(el), sec: section(el), x: Math.round(e.pageX), y: Math.round(e.pageY), i: interactive(el) ? 1 : 0 };
    var text = label(el);
    if (text) click.l = text;
    recent = recent.filter(function (c) { return now - c.at < 1000 && Math.abs(c.x - e.clientX) < 24 && Math.abs(c.y - e.clientY) < 24; });
    recent.push({ at: now, x: e.clientX, y: e.clientY });
    if (recent.length >= 3) { click.r = 1; rec.rage += 1; recent = []; replayTrigger("rage", click); }
    funnelFromClick(el);
    watchDead(click, el, e);
    if (rec.clicks.length < LIMIT.clicks) rec.clicks.push(click);
  }, { capture: true, passive: true });

  function watchDead(click, el, e) {
    var reacted = false;
    var startY = window.scrollY, startPath = location.href, startFocus = document.activeElement;
    var observer = null;
    try {
      // Only the clicked section, the drawers/dialogs appended to <body> and the classes of <html>:
      // carousels and countdowns elsewhere change the page all the time and would hide every dead click.
      observer = new MutationObserver(function () { reacted = true; });
      var scope = (el.closest && el.closest("[id^='shopify-section-']")) || document.body;
      observer.observe(scope, { childList: true, subtree: true, attributes: true, characterData: true });
      if (scope !== document.body) observer.observe(document.body, { childList: true });
      observer.observe(document.documentElement, { attributes: true });
    } catch (e) { reacted = true; }
    function reactedNow() { reacted = true; }
    // The next page has started loading (a link, a form, a script): it may take more than a second to arrive. Only
    // the latest click's: a dead tap followed within the second by a tap on a slow link stays dead.
    var mine = ++clickSeq;
    function navigated(event) {
      if (mine === clickSeq && (!event.destination || !event.destination.sameDocument)) reacted = true;
    }
    var navigation = window.navigation && window.navigation.addEventListener ? window.navigation : null;
    window.addEventListener("pagehide", reactedNow, { once: true });
    if (navigation) navigation.addEventListener("navigate", navigated);
    setTimeout(function () {
      if (observer) observer.disconnect();
      window.removeEventListener("pagehide", reactedNow);
      if (navigation) navigation.removeEventListener("navigate", navigated);
      if (reacted || window.scrollY !== startY || location.href !== startPath || document.activeElement !== startFocus) return;
      // Native editing is a response too: mousedown focused the field before this click's snapshot,
      // and moving its caret (or opening the number keyboard) need not mutate the DOM. Never read its value.
      var field = el.closest && el.closest("input,textarea");
      if (field && document.activeElement === field && !field.disabled && !field.readOnly &&
          (field.tagName === "TEXTAREA" || /^(text|email|number|search|tel|url|password|date|datetime-local|month|week|time)$/.test(field.type))) return;
      if (follows(el.closest && el.closest("a[href]"), e, startPath)) return;
      click.d = 1;
      rec.dead += 1;
      if (click.i) { rec.deadI += 1; replayTrigger("dead", click); }
    }, 1000);
  }

  /* A link the page let through: the browser follows it (the next page, a new tab, the mail app). On a phone the
     next page often comes after the second the check waits, and Safari moves neither the focus nor anything else
     meanwhile: 23/10/2026, 33 of the 35 «dead» taps on the menu's links were the page's last click, the next page
     arriving 1-2 s later (rum:dead «Maglie»). A link to a spot of this page shows as a scroll or a new address. */
  function follows(link, e, from) {
    if (!link || e.defaultPrevented || typeof link.href !== "string") return false;
    if (/^\s*(#|javascript:)/i.test(link.getAttribute("href") || "")) return false;
    var to = link.href.split("#");
    return to.length < 2 || to[0] !== from.split("#")[0];
  }

  function funnelFromClick(el) {
    if (el.closest("variant-picker label, .block-swatch, .op-size")) rec.f.size = 1;
    if (el.closest("button[name=checkout], a[href*='/checkout']")) rec.f.checkout = 1;
    if (el.closest("button.integrated-wishlist-heart")) rec.f.wish = 1;
  }

  /* ------------------------------------------------------------ scroll */
  var scrollTick = 0;
  window.addEventListener("scroll", function () {
    if (!human || scrollTick) return;
    scrollTick = setTimeout(function () {
      scrollTick = 0;
      var height = Math.max(document.documentElement.scrollHeight, 1);
      var seen = Math.min(100, Math.round((window.scrollY + window.innerHeight) / height * 100));
      if (seen > rec.scroll) rec.scroll = seen;
    }, 250);
  }, { passive: true });

  /* ------------------------------------------------------------ errors */
  function ownSource(src) {
    if (!src) return "inline";
    if (src.indexOf(location.host) !== -1 || src.indexOf("/cdn/shop/t/") !== -1) return "theme";
    if (src.indexOf("cdn.shopify.com/extensions/") !== -1 || src.indexOf("onrender.com") !== -1) return "app";
    return "";
  }
  /* the in-app browsers of iOS apps (Facebook, Instagram, Chrome, Edge) run their own code in the page and its
     errors carry the page's address as their file: names of that code, never ours */
  var INJECTED = /_AutofillCallbackHandler|_pcmBridgeCallbackHandler|__gCrWeb|__firefox__|instantSearchSDKJSBridge|webkit\.messageHandlers/;
  function pushError(message, src, line) {
    if (rec.errors.length >= LIMIT.errors || !message || /^Script error\.?$/.test(message) || INJECTED.test(message)) return;
    var owner = ownSource(src);
    if (!owner) return;
    var file = String(src || "").split("?")[0].split("/").pop().slice(0, 60);
    rec.errors.push({ m: String(message).slice(0, 140), f: file, n: line || 0, o: owner, t: Date.now() - t0 });
    replayTrigger("error", { m: String(message).slice(0, 140), f: file });
  }
  window.addEventListener("error", function (e) {
    /* "ResizeObserver loop completed with undelivered notifications" (older Chrome: "loop limit exceeded") is the
       browser's notice that a resize was handed to the next frame, raised by no script (the page's address stands as
       its file): nothing failed, and it cannot be traced to any code */
    if (e && e.message && !/ResizeObserver loop/.test(e.message)) pushError(e.message, e.filename, e.lineno);
  });
  window.addEventListener("unhandledrejection", function (e) {
    var reason = e && e.reason;
    var message = reason && (reason.message || String(reason));
    if (/failed to fetch|load failed|networkerror|aborted/i.test(String(message))) return;
    /* the browser aborts a page transition (the crossfade between pages) when the visitor moves on or the page
       loads at once: an AbortError "Skipping view transition because skipTransition() was called", not a fault */
    if ((reason && reason.name === "AbortError") || /view transition/i.test(String(message))) return;
    var stack = reason && reason.stack ? String(reason.stack) : "";
    var src = (stack.match(/https?:\/\/[^\s)]+/) || [""])[0].replace(/:\d+:\d+$/, "");
    pushError(message, src, 0);
  });

  /* ------------------------------------------------------------ cart and app requests */
  window.addEventListener("sks:cart-request", function (e) {
    var d = e.detail || {};
    if (rec.cart.length >= LIMIT.cart) return;
    rec.cart.push({ p: String(d.path || "").slice(0, 40), s: d.status || 0, ms: Math.round(d.ms || 0), t: Date.now() - t0 });
    if (/\/cart\/add/.test(d.path || "")) {
      rec.f.atc = (rec.f.atc || 0) + 1;
      if (d.status >= 200 && d.status < 300) rec.f.atcOk = 1;
      if (!d.status || d.status >= 500) replayTrigger("atc", { s: d.status || 0 });
    }
  });
  var OWN_REQUEST = /\/apps\/|\/cart|\/search|onrender\.com|\/recommendations/;
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        var status = entry.responseStatus;
        if (!status || status < 400 || !OWN_REQUEST.test(entry.name) || rec.res.length >= LIMIT.res) return;
        var url;
        try { url = new URL(entry.name); } catch (e) { return; }
        rec.res.push({ u: (url.host === location.host ? "" : url.host) + url.pathname.slice(0, 80), s: status });
      });
    }).observe({ type: "resource", buffered: false });
  } catch (e) { /* older browsers: the cart events still arrive */ }

  /* ------------------------------------------------------------ web vitals
     As Google counts them (12/10/2026, docs/journey-monitor-runbook.md «Core Vitals»), with what explains them:
     - LCP and its four parts as CrUX splits it: server (TTFB), wait before the resource, its download, the render
       after it (lcpPh), whether it is an image or text and the image's file name; LCP and FCP count from the
       activation of a prerendered page and not at all for a page loaded in a background tab;
     - INP: the slowest interaction, ignoring one for every 50 (Google's 98th percentile), its three phases (input
       delay, processing, presentation: inpPh), the event, whether it was the page's first interaction and the
       script that ran longest in the frames it waited for (long animation frames: file and function names only);
     - CLS: the largest session window (shifts less than 1 s apart, at most 5 s), as Google, not the sum; the element
       that moved most in it, when and at what scroll position;
     - FCP and TTFB. */
  function observe(type, fn, opts) {
    try { new PerformanceObserver(function (l) { l.getEntries().forEach(fn); }).observe(Object.assign({ type: type, buffered: true }, opts || {})); } catch (e) {}
  }
  function navEntry() { try { return performance.getEntriesByType("navigation")[0] || null; } catch (e) { return null; } }
  function fileOf(url) { return String(url || "").split("#")[0].split("?")[0].split("/").pop().slice(0, 80); }
  // A prerendered page counts from its activation, which is known only once the visitor opens it: read when sending.
  function activationStart() { var nav = navEntry(); return (nav && nav.activationStart) || 0; }
  // As web-vitals: no paint after the page was first hidden counts (a tab opened in the background paints only when
  // the visitor turns to it); a prerendered page is hidden until its activation, which is not that.
  var hiddenAt = document.visibilityState === "hidden" && !document.prerendering ? 0 : Infinity;
  try {
    if (!document.prerendering) performance.getEntriesByType("visibility-state").forEach(function (e) {
      if (e.name === "hidden" && e.startTime >= activationStart()) hiddenAt = Math.min(hiddenAt, e.startTime);
    });
  } catch (e) {}
  document.addEventListener("visibilitychange", function (e) {
    if (document.visibilityState === "hidden") hiddenAt = Math.min(hiddenAt, e.timeStamp);
  }, true);
  var lcpEntry = null, fcpEntry = null;
  observe("largest-contentful-paint", function (entry) {
    if (entry.startTime >= hiddenAt) return;
    lcpEntry = entry;
    rec.vit.lcp = Math.round(Math.max(0, entry.startTime - activationStart()));
    rec.vit.lcpEl = entry.element ? selector(entry.element) : "";
    rec.vit.lcpType = entry.url ? "img" : "text";
    if (entry.url) rec.vit.lcpRes = fileOf(entry.url);
  });
  observe("paint", function (entry) { if (entry.name === "first-contentful-paint" && entry.startTime < hiddenAt) fcpEntry = entry; });
  function paints() {
    var nav = navEntry(), act = activationStart();
    if (fcpEntry) rec.vit.fcp = Math.round(Math.max(0, fcpEntry.startTime - act));
    if (!nav) return;
    var ttfb = Math.max(0, nav.responseStart - act);
    if (nav.responseStart > 0) rec.vit.ttfb = Math.round(ttfb);
    if (!lcpEntry) return;
    var lcp = Math.max(ttfb, lcpEntry.startTime - act);
    var res = null;
    if (lcpEntry.url) {
      try { res = performance.getEntriesByType("resource").filter(function (r) { return r.name === lcpEntry.url; })[0] || null; } catch (e) {}
    }
    var start = res ? Math.max(ttfb, (res.requestStart || res.startTime) - act) : ttfb;
    var end = res ? Math.min(lcp, Math.max(start, res.responseEnd - act)) : ttfb;
    rec.vit.lcp = Math.round(lcp);
    rec.vit.lcpPh = [Math.round(ttfb), Math.round(start - ttfb), Math.round(end - start), Math.round(lcp - end)];
  }

  var cls = { value: 0, start: -1, last: -1, worst: null, best: 0, bestWorst: null };
  observe("layout-shift", function (entry) {
    if (entry.hadRecentInput) return;
    if (cls.last < 0 || entry.startTime - cls.last >= 1000 || entry.startTime - cls.start >= 5000) {
      cls.value = 0; cls.start = entry.startTime; cls.worst = null;
    }
    cls.value += entry.value;
    cls.last = entry.startTime;
    var node = entry.sources && entry.sources.filter(function (s) { return s.node; }).sort(function (a, b) {
      return b.currentRect.width * b.currentRect.height - a.currentRect.width * a.currentRect.height;
    })[0];
    if (!cls.worst || entry.value > cls.worst.v) {
      cls.worst = { v: entry.value, el: node ? selector(node.node.nodeType === 1 ? node.node : node.node.parentElement) : "",
                    t: Math.round(entry.startTime), y: Math.round(window.scrollY) };
    }
    if (cls.value > cls.best) { cls.best = cls.value; cls.bestWorst = cls.worst; }
    rec.vit.cls = Math.round(cls.best * 1000) / 1000;
    if (cls.bestWorst) { rec.vit.clsEl = cls.bestWorst.el; rec.vit.clsT = cls.bestWorst.t; rec.vit.clsY = cls.bestWorst.y; }
  });

  // One interaction is several events (pointerdown, pointerup, click; keydown, keyup). As web-vitals does, its latency
  // is its longest event's and its phases are that event's, up to the end of the last handler painted in the same
  // frame (8 ms apart): a finger held on the screen between pointerdown and pointerup never counts as processing.
  var interactions = {}, slowest = [], firstInteraction = 0, frames = [];
  observe("long-animation-frame", function (entry) {
    frames.push(entry);
    if (frames.length > 40) frames.shift();
  });
  observe("event", function (entry) {
    var id = entry.interactionId;
    if (!id) return;
    if (!firstInteraction || id < firstInteraction) firstInteraction = id;
    var it = interactions[id] || (interactions[id] = { id: id, d: 0, events: [], target: null });
    if (it.events.length < 12) {
      it.events.push({ s: entry.startTime, ps: entry.processingStart, pe: entry.processingEnd, d: entry.duration, name: entry.name });
    }
    it.d = Math.max(it.d, entry.duration);
    if (!it.target && entry.target) it.target = entry.target;
    slowest = Object.keys(interactions).map(function (key) { return interactions[key]; })
      .sort(function (a, b) { return b.d - a.d; }).slice(0, 10);
    var keep = {};
    slowest.forEach(function (one) { keep[one.id] = one; });
    interactions = keep;
  }, { durationThreshold: 16 });
  function inp() {
    if (!slowest.length) return;
    var count = 0;
    try { count = performance.interactionCount || 0; } catch (e) {}
    var it = slowest[Math.min(slowest.length - 1, Math.floor(Math.max(count, slowest.length) / 50))];
    var longest = it.events.reduce(function (a, b) { return b.d > a.d ? b : a; });   // the first of equals
    var end = longest.s + longest.d;
    var painted = it.events.filter(function (e) { return Math.abs(e.s + e.d - end) <= 8; });
    var handled = Math.max.apply(null, painted.map(function (e) { return e.pe; }));
    var work = painted.reduce(function (a, b) { return b.pe - b.ps > a.pe - a.ps ? b : a; });
    rec.vit.inp = Math.round(it.d);
    rec.vit.inpEl = it.target && it.target.nodeType === 1 ? selector(it.target) : "";
    rec.vit.inpType = String(work.name || "").slice(0, 12);
    rec.vit.inpPh = [Math.round(Math.max(0, longest.ps - longest.s)), Math.round(Math.max(0, handled - longest.ps)), Math.round(Math.max(0, end - handled))];
    rec.vit.inpFirst = it.id === firstInteraction ? 1 : 0;
    if (count) rec.vit.inpN = count;
    var best = null;
    frames.forEach(function (frame) {
      if (frame.startTime > end || frame.startTime + frame.duration < longest.s) return;
      (frame.scripts || []).forEach(function (script) { if (!best || script.duration > best.duration) best = script; });
    });
    if (best && best.duration >= 20) {
      rec.vit.inpScr = (fileOf(best.sourceURL) || "inline") + (best.sourceFunctionName ? " " + String(best.sourceFunctionName).slice(0, 40) : "")
        + " " + Math.round(best.duration) + "ms";
    } else delete rec.vit.inpScr;
  }
  function vitalsNow() {   // the page keeps what it has when one of them fails
    try { paints(); } catch (e) {}
    try { inp(); } catch (e) {}
  }

  /* ------------------------------------------------------------ quick back */
  var LAST_KEY = "sks_jm_last";
  try {
    var nav = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
    var last = JSON.parse(sessionStorage.getItem(LAST_KEY) || "null");
    if (nav && nav.type === "back_forward" && last && last.ms < 5000) page.qb = String(last.path).slice(0, 200);
  } catch (e) {}

  /* ------------------------------------------------------------ replay (phase 4) */
  var REPLAY_URL = ENDPOINT.replace(/\/collect(?=\?|$)/, "/replay");
  var REPLAY_WINDOW = 120000, CHUNK_MAX = 480000, BEACON_MAX = 60000, FULL_PAGES = 10, QUIET_MS = 1500, CHECKOUT_MS = 30000;
  var replay = { mode: "", lib: null, buffer: [[], []], queue: [], trig: [], seq: 0, sending: false, timer: 0, snapshotAt: 0, waiting: false };
  function share(value) { var n = parseFloat(value); return n > 0 ? Math.min(1, n) : 0; }
  function store(key, value) { try { if (value === undefined) return sessionStorage.getItem(key); sessionStorage.setItem(key, String(value)); } catch (e) {} return null; }
  function replayMode() {
    if (typeof CompressionStream !== "function" || typeof Response !== "function" || !window.fetch || !cfg.rrweb) return "";
    if (/^search/.test(String(cfg.template || ""))) return "";   // the page prints what was searched
    if (/[?&]jm=2(&|$)/.test(location.search)) store("sks_jm_r", "f");
    var mode = store("sks_jm_r");
    if (!mode) {
      var full = share(cfg.replayFull), roll = Math.random();
      mode = roll < full ? "f" : roll < full + share(cfg.replay) ? "b" : "n";
      store("sks_jm_r", mode);
    }
    if (mode === "f") {
      var pages = (+store("sks_jm_rp") || 0) + 1;
      store("sks_jm_rp", pages);
      return pages <= FULL_PAGES ? "full" : "";
    }
    if (mode !== "b") return "";
    return Date.now() - (+store("sks_jm_rt") || 0) < REPLAY_WINDOW ? "upload" : "buffer";
  }
  function idle(fn) { if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 3000 }); else setTimeout(fn, 1500); }
  // A snapshot of the page is one block of work (100-150 ms on a mid phone): it runs only when the
  // visitor has not touched, scrolled or typed for QUIET_MS and the browser is idle, never during a tap.
  function whenQuiet(fn) {
    (function wait() {
      var still = Date.now() - lastInput;
      if (still < QUIET_MS) { setTimeout(wait, QUIET_MS - still + 50); return; }
      idle(function () { if (Date.now() - lastInput < QUIET_MS) wait(); else fn(); });
    })();
  }
  function startReplay() {
    if (replay.mode || !(replay.mode = replayMode())) return;
    whenQuiet(function () {
      var script = document.createElement("script");
      script.src = cfg.rrweb;
      script.async = true;
      script.onload = function () { whenQuiet(recordReplay); };
      document.head.appendChild(script);
    });
  }
  function checkout() {   // a fresh snapshot for the buffer, so it never holds more than 30-60 s
    replay.waiting = false;
    if (replay.mode !== "buffer" || !replay.lib) return;
    replay.snapshotAt = Date.now();
    try { replay.lib.takeFullSnapshot(true); } catch (e) {}
  }
  function recordReplay() {
    var lib = window.rrwebRecord && window.rrwebRecord.record;
    if (!lib || replay.lib) return;
    replay.lib = lib;
    replay.snapshotAt = Date.now();
    var buffering = replay.mode === "buffer";
    lib({
      emit: function (event, isCheckout) {
        if (event.type === 4 && event.data && event.data.href) event.data.href = String(event.data.href).split(/[?#]/)[0];
        if (replay.mode !== "buffer") { replay.queue.push(event); return; }
        if (isCheckout) replay.buffer = [replay.buffer[1], []];
        replay.buffer[1].push(event);
      },
      maskAllInputs: true,
      maskTextSelector: "form, address, [data-jm-mask]",
      blockSelector: "iframe, video, canvas, predictive-search, .luxe-search-recent, [data-jm-block]",
      recordCanvas: false, collectFonts: false, inlineImages: false, inlineStylesheet: false, slimDOMOptions: "all",
      sampling: { mousemove: 100, scroll: 150, media: 800, input: "last" }
    });
    if (!buffering) replay.timer = setInterval(sendReplay, 10000);
    else setInterval(function () {
      if (replay.mode === "buffer" && !replay.waiting && Date.now() - replay.snapshotAt > CHECKOUT_MS) { replay.waiting = true; whenQuiet(checkout); }
    }, 10000);
  }
  function replayTrigger(kind, what) {
    if (!replay.mode) return;
    var detail = { k: kind };
    ["m", "f", "s", "sec", "l"].forEach(function (key) { if (what && what[key]) detail[key] = String(what[key]).slice(0, 200); });
    if (kind === "atc") detail.s = String(what.s);
    if (replay.trig.length < 10) replay.trig.push(detail);
    store("sks_jm_rt", Date.now());
    try { if (replay.lib) replay.lib.addCustomEvent("jm-trigger", detail); } catch (e) {}
    if (replay.mode !== "buffer") return;
    replay.mode = "upload";   // what led here, then the rest of the page
    replay.queue = replay.buffer[0].concat(replay.buffer[1], replay.queue);
    replay.buffer = [[], []];
    if (replay.lib) replay.timer = replay.timer || setInterval(sendReplay, 10000);
    sendReplay();
  }
  function replayHead(enc, final) {
    return JSON.stringify({ v: 1, sid: sid, pid: pid, seq: replay.seq++, mode: replay.mode, enc: enc, final: final ? 1 : 0,
      trig: replay.trig.splice(0), path: page.path, tpl: page.tpl, dev: page.dev, vw: page.vw, loc: page.loc, mkt: page.mkt }) + "\n";
  }
  function sendReplay() {
    if (replay.sending || !replay.queue.length || replay.mode === "buffer" || !replay.mode) return;
    var events = replay.queue.splice(0);
    replay.sending = true;
    new Response(new Blob([JSON.stringify(events)]).stream().pipeThrough(new CompressionStream("gzip"))).arrayBuffer()
      .then(function (gz) {
        if (gz.byteLength > CHUNK_MAX) return;
        return fetch(REPLAY_URL, { method: "POST", mode: "no-cors", headers: { "Content-Type": "text/plain" },
          body: new Blob([replayHead("gzip", false), gz]) });
      })
      .catch(function () {})
      .then(function () { replay.sending = false; });
  }
  function replayFinal() {
    if (replay.mode !== "upload" && replay.mode !== "full" || !replay.queue.length) return;
    var text = JSON.stringify(replay.queue.splice(0));
    if (text.length > BEACON_MAX) return;   // too late to compress: the last seconds are lost
    try { navigator.sendBeacon(REPLAY_URL, new Blob([replayHead("json", true) + text], { type: "text/plain" })); } catch (e) {}
  }

  /* ------------------------------------------------------------ sending */
  var sent = 0;
  function payload(final) {
    var body = {};
    for (var k in page) body[k] = page[k];
    body.final = final ? 1 : 0;
    body.ms = Date.now() - t0;
    body.clicks = rec.clicks; body.rage = rec.rage; body.dead = rec.dead; body.deadI = rec.deadI;
    body.errors = rec.errors; body.cart = rec.cart; body.res = rec.res; body.scroll = rec.scroll;
    body.vit = rec.vit; body.f = rec.f;
    if (replay.lib) body.rp = 1;   // rrweb recorded this page: its INP is compared with the others
    return JSON.stringify(body);
  }
  function beacon(text) {
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([text], { type: "text/plain" }))) return;
    } catch (e) {}
    try { fetch(ENDPOINT, { method: "POST", body: text, keepalive: true, mode: "no-cors", headers: { "Content-Type": "text/plain" } }); } catch (e) {}
  }
  var lastSent = "";
  function flush(final) {
    if (!human) return;
    vitalsNow();
    var state = JSON.stringify(rec);   // nothing new since the last beacon: nothing to send
    if (state === lastSent) return;
    lastSent = state;
    var text = payload(final);
    if (text.length > 60000) { rec.clicks = rec.clicks.slice(0, 20); text = payload(final); }
    sent += 1;
    beacon(text);
  }
  onHuman(function () { setInterval(function () { if (document.visibilityState === "visible") flush(false); }, 30000); });
  onHuman(startReplay);

  // Pages without a human gesture: 1% of them count, with a few hints, for the bot share.
  var SAMPLE = Math.min(1, Math.max(0, parseFloat(cfg.sample == null ? "0.01" : cfg.sample) || 0));
  function hints() {
    var h = { pl: (navigator.plugins || []).length, ch: window.chrome ? 1 : 0, ow: window.outerWidth || 0, lang: (navigator.language || "").slice(0, 10) };
    try { h.tz = Intl.DateTimeFormat().resolvedOptions().timeZone.slice(0, 40); } catch (e) {}
    if (page.dev === "d") {
      try {
        var gl = document.createElement("canvas").getContext("webgl");
        var info = gl && gl.getExtension("WEBGL_debug_renderer_info");
        if (info) h.gl = String(gl.getParameter(info.UNMASKED_RENDERER_WEBGL)).slice(0, 60);
      } catch (e) {}
    }
    return h;
  }
  var hintData = null;
  setTimeout(function () { if (!human && Math.random() < SAMPLE) hintData = hints(); }, 5000);

  function leave() {
    try { sessionStorage.setItem(LAST_KEY, JSON.stringify({ path: location.pathname, ms: Date.now() - t0 })); } catch (e) {}
    if (human) { flush(true); replayFinal(); return; }
    if (!hintData || sent) return;
    sent += 1;
    beacon(JSON.stringify({ v: 1, k: "c", tpl: page.tpl, path: page.path, loc: page.loc, mkt: page.mkt, dev: page.dev,
      ref: page.ref, utm: page.utm, ms: Date.now() - t0, h: hintData }));
  }
  window.addEventListener("pagehide", leave);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") { if (human) flush(false); sendReplay(); }
  });
})();
